<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>

                    <el-date-picker
                            v-model="weekValue"
                            type="week"
                            format="yyyy 第 WW 周" ref="week" placeholder="选择周" value-format="yyyy-MM-dd"
                            :picker-options="{'firstDayOfWeek': 1}" @change="selectWeek">
                    </el-date-picker>

                </el-form-item>
                <el-form-item>
                    <el-select v-model="sectionClassId" placeholder="请选择类型">
                        <el-option
                                v-for="item in cooperItem"
                                :label="item.label"
                                :key="item.value"
                                :value="item.value">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativeList">查询</el-button>
                </el-form-item>

            </el-form>
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="姓名" prop="userName"></el-table-column>
                <el-table-column label="期间" prop="periodName"></el-table-column>
                <el-table-column label="填写时间">
                    <template slot-scope="scope">
                        <span style="color: #41B883">{{scope.row.startEditTime}}-{{scope.row.endEditTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="填写状态" prop="statusName"></el-table-column>
                <el-table-column label="数据来源" width="200">
                    <template slot-scope="scope">
                        <el-date-picker
                                v-model="weekValue1"
                                type="week"
                                format="yyyy 第 WW 周" ref="week" placeholder="选择周" value-format="yyyy-MM-dd"
                                :picker-options="{'firstDayOfWeek': 1}" @change="selectWeek1" style="width: 100%">
                        </el-date-picker>
                        <el-select v-model="sectionUser" placeholder="请选择类型">
                            <el-option
                                    v-for="item in dataList1"
                                    :key="item.id"
                                    :label="item.userName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-button v-if="scope.row.isEdit==1" type="success" size="mini" @click="getCooperativeQues1(sectionUser)">获取数据</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isEdit==1" type="danger" size="mini" @click="getCooperativeQues(scope.row)">修改</el-button>
                        <el-button v-if="scope.row.isEdit==0" :type="scope.row.isLeader==0||scope.row.isLeader==2?'warning':'success'" size="mini" @click="getCooperativeQues(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    :hide-on-single-page="formInline.pageSize>=recordsTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-drawer
                :title="title"
                :visible.sync="drawerShow"
                direction="rtl"

                :before-close="handleClose" size="70%" style="margin-bottom:0px;">

            <div style="padding: 5px 20px;">
<!--                <span>{{this.title}}</span>-->
                <template v-for="(item,index) in quesList">
                    <div>
                        <p>
                            <span><b style="color: red">{{item.required==1?'*':''}}</b>{{index+1}} .</span>
                            <span v-html="item.questionName"></span>
                        </p>
                        <p style="font-size: 10px;color:grey" v-html="item.questionDesc"></p>
                        <div>
                            <template v-if="item.questionType==2">
                                <el-select v-model="item.answer"  placeholder="请选择" @change="formSubmit(item)">
                                    <el-option
                                            v-for="opt in JSON.parse(item.questionOption)"
                                            :key="opt.code"
                                            :label="opt.name"
                                            :value="opt.code" :disabled="editIs==0||item.readonly">
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.questionType==3">
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadFile"
                                        :on-success="handleFileChange"
                                        :on-preview="handleFileView"
                                        :on-remove="handleFileRemove"
                                        :file-list="fileObjList" :disabled="editIs==0||item.readonly">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </template>
                            <template v-else-if="item.questionType==4">
                                <el-row :gutter="20">
                                    <el-col :sm="10" :xs="24">
                                        <el-select v-model="item.answer"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch"
                                                   @change="formSubmit(item)"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                            <el-option
                                                    v-for="user in selectUserList"
                                                    :key="user.USER_ID"
                                                    :label="user.USER_NAME"
                                                    :value="user.USER_ID">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :sm="12" :xs="20">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                autosize
                                                placeholder="你想要感谢的是什么"
                                                @blur="formSubmit(item)"
                                                v-model="item.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                        </el-input>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==5">
                                <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                    <el-col :sm="10" :xs="24">
                                        <el-select v-model="rel.relationUserId"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch1"
                                                   @change="formSubmit(item)"
                                                   @focus="selectFocus(relIndex)"
                                                   ref="select"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                            <template v-if="currentSelectIndex==relIndex">
                                                <el-option
                                                        v-for="user in selectUserList1"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :disabled="user.enable==0"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>
                                            <template v-else>
                                                <el-option
                                                        v-for="user in userAllList"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :disabled="user.enable==0"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>

                                        </el-select>
                                    </el-col>
                                    <el-col :sm="12" :xs="20">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                autosize
                                                placeholder="你想要感谢的是什么"
                                                @blur="formSubmit(item)"
                                                v-model="rel.content" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                        </el-input>
                                    </el-col>
                                    <el-col :sm="2" :xs="4">
                                        <el-button v-if="relIndex==0" :disabled="editIs==0||item.readonly" type="success" icon="el-icon-plus" circle size="small" @click="addQues(item)"></el-button>
                                        <el-button v-else type="danger" :disabled="editIs==0||item.readonly" icon="el-icon-minus" circle size="small" @click="minuQues(item,rel,relIndex)"></el-button>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==6">
                                <el-button :disabled="(leaderIs!=0||editIs==0||item.readonly)&&(leaderIs!=1||isLeaderEdit==0)" type="success" size="small" @click="addQues(item)">添加周事周毕</el-button>
                                <span style="color: red;">(*注意: 请逐条添加)</span>
                                <div class="drag-container" style="margin-top: 10px">
                                    <table class="drag-container">
                                        <thead>
                                            <tr style="font-size: 12px">
                                                <th width="50">序号</th>
                                                <th>工作内容</th>
                                                <th width="90">完成时间</th>
                                                <th width="60">添加人</th>
                                                <th width="70">提出异议</th>
                                                <th width="70">操作</th>
                                            </tr>
                                        </thead>
                                        <draggable v-model="item.relationEntityList" tag="tbody" @change="changeListSort">
                                            <tr v-for="(rel,relIndex) in item.relationEntityList">
                                                <td>{{relIndex+1}}</td>
                                                <td style="padding: 12px 6px;">
                                                    <el-input
                                                            type="textarea"
                                                            :rows="2"
                                                            autosize
                                                            placeholder="这周要做的事"
                                                            @blur="formSubmit(item)"
                                                            v-model="rel.content" :disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))" maxlength="140" show-word-limit>
                                                    </el-input>
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <el-select v-model="rel.weekName"
                                                               clearable
                                                               size="mini"
                                                               @change="formSubmit(item)"
                                                               placeholder="选周" :disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))">
                                                        <el-option
                                                                v-for="week in weekSelectList"
                                                                :key="week.value"
                                                                :label="week.text"
                                                                :value="week.value">
                                                        </el-option>
                                                    </el-select>
                                                </td>
                                                <td>
                                                    <el-tag v-if="rel.isLeader==1" type="success" size="mini">Leader</el-tag>
                                                    <el-tag v-if="rel.isLeader==0" type="primary" size="mini">Self</el-tag>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isDissent" :disabled="leaderIs!=0||rel.isLeader!=1||rel.id==null||isDissentEdit==0" :true-label="1" :false-label="0" size="medium" @change="formSubmit(item)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-button :disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))" type="danger" size="small" @click="minuQues(item,rel,relIndex)" icon="el-icon-delete" circle></el-button>
                                                </td>
                                            </tr>
                                        </draggable>
                                    </table>
                                </div>
                            </template>
                            <template v-else-if="item.questionType==7">
                                <el-table :data="JSON.parse(item.answer.toString())" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="上月价值创造目标" prop="lastMonthValue"></el-table-column>
                                    <el-table-column label="上月实际价值创造计算" prop="lastMonthFactValue"></el-table-column>
                                    <el-table-column label="下个月价值创造目标" prop="nextMonthValue"></el-table-column>
                                </el-table>
                            </template>
                            <template v-else-if="item.questionType==8">
                                <el-input
                                        type="textarea"
                                        :rows="1"
                                        autosize
                                        placeholder=""
                                        v-model="item.answer" :disabled="true" maxlength="5000" show-word-limit>
                                </el-input>
                            </template>
                            <template v-else-if="item.questionType==9">
                                <el-checkbox @change="formSubmit(item)"
                                             v-model="tab.check"
                                             style="margin-bottom: 10px;margin-left: 0px!important;"
                                             size="mini" v-for="tab in item.answer"
                                             :label="tab.name"
                                             :true-label="1"
                                             :false-label="0"
                                             :key="tab.code"
                                             :disabled="editIs==0||item.readonly"
                                             border></el-checkbox>
                            </template>
                            <template v-else-if="item.questionType==10">
                                <template v-for="(supItem,supIndex) in item.subPaperAnswerEditVos">
                                    <div style="margin-left: 20px">
                                        <p>
                                            <span>{{supIndex+1}}) .</span>
                                            <span v-html="supItem.questionName"></span>
                                        </p>
                                        <template v-if="supItem.questionType==9">
                                            <el-checkbox
                                                    v-model="tab.check"
                                                    :true-label="1"
                                                    :false-label="0"
                                                    @change="formSubmit(item)"
                                                    style="margin-bottom: 10px;margin-left: 0px!important;"
                                                    size="mini"
                                                    v-for="tab in supItem.answer"
                                                    :key="tab.code"
                                                    :disabled="editIs==0||item.readonly"
                                                    :label="tab.name" border></el-checkbox>
                                        </template>
                                        <template v-else-if="supItem.questionType==12">
                                            <el-input-number v-model="supItem.answer" @change="formSubmit(item)" :min="supItem.questionNumberMin" :max="supItem.questionNumberMax" label="请输入内容" :disabled="editIs==0||item.readonly"></el-input-number>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    type="textarea"
                                                    :rows="2"
                                                    autosize
                                                    placeholder="请输入内容"
                                                    @blur="formSubmit(item)"
                                                    v-model="supItem.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="item.questionType==11">
                                <el-select v-model="item.answer"
                                           filterable
                                           remote
                                           clearable
                                           reserve-keyword
                                           :remote-method="querySearch"
                                           @change="formSubmit(item)"
                                           placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                    <el-option
                                            v-for="user in selectUserList"
                                            :key="user.USER_ID"
                                            :label="user.USER_NAME"
                                            :value="user.USER_ID">
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.questionType==14">
                                <el-table :data="JSON.parse(item.answer.toString())" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="周次" prop="dateWeek" width="100"></el-table-column>
                                    <el-table-column label="今日完成">
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.todayAnswer" style="text-align: left"></p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="明日必完成">
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.tomorrowAnswer" style="text-align: left"></p>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            <template v-else-if="item.questionType==15">

                                <div class="drag-container" style="margin-top: 10px">
                                    <table class="drag-container">
                                        <thead>
                                        <tr style="font-size: 12px">
                                            <th width="50">序号</th>
                                            <th>工作内容</th>
                                            <th width="90">完成时间</th>
                                            <th width="60">添加人</th>
                                            <th width="70">提出异议</th>
                                            <th width="70">确认完成</th>
                                            <th width="70">领导确认</th>
                                        </tr>
                                        </thead>
                                        <draggable v-model="item.relationEntityListTwo" tag="tbody" @change="changeListSort">
                                            <tr v-for="(rel,relIndex) in item.relationEntityListTwo">
                                                <td>{{relIndex+1}}</td>
                                                <td style="padding: 12px 6px;">
                                                    <el-input
                                                            type="textarea"
                                                            :rows="2"
                                                            autosize
                                                            placeholder="这周要做的事"
                                                            @blur="formSubmit(item)"
                                                            v-model="rel.content" disabled maxlength="5000" show-word-limit>
                                                    </el-input>
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <el-select v-model="rel.weekName"
                                                               clearable
                                                               size="mini"
                                                               @change="formSubmit(item)"
                                                               placeholder="选周" disabled>
                                                        <el-option
                                                                v-for="week in weekSelectList"
                                                                :key="week.value"
                                                                :label="week.text"
                                                                :value="week.value">
                                                        </el-option>
                                                    </el-select>
                                                </td>
                                                <td>
                                                    <el-tag v-if="rel.isLeader==1" type="success" size="mini">Leader</el-tag>
                                                    <el-tag v-if="rel.isLeader==0" type="primary" size="mini">Self</el-tag>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isDissent" disabled :true-label="1" :false-label="0" size="medium" @change="formSubmit(item)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isFinishEmploye" :disabled="leaderIs!=0||rel.id==null" :true-label="1" :false-label="0" size="medium" @change="submitWeekCheck(rel)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isFinishLeader" :disabled="leaderIs!=1||rel.id==null||isLeaderEdit==0" :true-label="1" :false-label="0" size="medium" @change="submitWeekCheck(rel)"></el-checkbox>
                                                </td>
                                            </tr>
                                        </draggable>
                                    </table>
                                </div>
                                <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                    <el-col :sm="12">
                                        <el-input
                                                placeholder="请输入业务指标"
                                                @blur="formSubmit(item)"
                                                v-model="rel.answerContent" :disabled="editIs==0||item.readonly">
                                            <template slot="prepend">业务指标:</template>
                                        </el-input>
                                    </el-col>
                                    <el-col :sm="12">
                                        <el-input
                                                placeholder="请输入实际达成"
                                                @blur="formSubmit(item)"
                                                v-model="rel.answerContent1" :disabled="editIs==0||item.readonly" >
                                            <template slot="prepend">实际达成:</template>

                                        </el-input>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==16">
                                <el-date-picker
                                        v-model="item.answer"
                                        type="date"
                                        @change="formSubmit(item)"
                                        :disabled="editIs==0||item.readonly"
                                        placeholder="选择日期">
                                </el-date-picker>

                            </template>
                            <template v-else>
                                <el-input
                                        type="textarea"
                                        :rows="2"
                                        autosize
                                        placeholder="请输入内容"
                                        @blur="formSubmit(item)"
                                        v-model="item.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                </el-input>
                            </template>

                        </div>
                    </div>
                </template>
                <div style="text-align: center">
                    <el-button v-if="editIs==1" type="danger" @click="formSubmit('')" :disabled="editIs==0">保存</el-button>
                    <template v-else >
                        <el-button v-if="formInline.classId==9" type="danger" @click="formSubmit('')" :disabled="leaderIs!=1||isLeaderEdit==0">保存</el-button>

                        <template v-if="formInline.classId==8&&leaderIs==1">
                            <el-button type="primary" :disabled="reportFinish==0" @click="showDialogLeader=true">leader评价</el-button>
                        </template>
                        <el-button v-if="formInline.classId==1||formInline.classId==2||formInline.classId==2" :disabled="reportFinish==0||voitIs==0" type="primary" @click="showCommentDialog(1)">点赞</el-button>
                        <el-button v-if="formInline.classId==1||formInline.classId==2" type="danger" :disabled="reportFinish==0" @click="showCommentDialog(2)">评论</el-button>

                    </template>
                </div>

            </div>
        </el-drawer>
        <el-dialog
                :title="dialogType==2?'评论原因':'点赞原因'"
                :visible.sync="showDialog"
                width="50%"
                center
                @close="closeLikeDialog">
            <el-input
                    type="textarea"
                    :rows="2"
                    autosize
                    placeholder="请输入内容"
                    v-model="likeCommitContent" maxlength="5000" show-word-limit>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="likeCommitContent.length<=0" @click="cooperativeLike(paperId,periodId)">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
                :title="'Leader评价'"
                :visible.sync="showDialogLeader"
                width="50%"
                center>
            <el-checkbox v-model="reportStatus" :true-label="1" :false-label="0">是否合格</el-checkbox>
            <el-checkbox v-model="isNice" :true-label="1" :false-label="0">是否推荐优秀复盘</el-checkbox>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitLeaderComment(paperId,periodId)">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';
    import draggable from 'vuedraggable'



    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                dataList1: [],
                quesList:[],
                weekValue:new Date(),
                weekValue1:new Date(),
                weekText:'',
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    year:'',
                    period:'',
                    userId:''
                },
                recordsTotal:0,
                drawerShow:false,
                editIs:0,
                voitIs:0,
                leaderIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:'',
                showDialogLeader:false,
                reportStatus:0,
                reportFinish:0,
                isNice:0,
                userId:'',
                title:'内容(*必填)',
                isLeaderEdit:0,
                isDissentEdit:0,
                weekSelectList:[
                    {text:'周一',value:'1'},
                    {text:'周二',value:'2'},
                    {text:'周三',value:'3'},
                    {text:'周四',value:'4'},
                    {text:'周五',value:'5'},
                    {text:'周六',value:'6'},
                    {text:'周日',value:'7'},
                ],
                sectionClassId:1,
                sectionUser:'',
                cooperItem:[{
                    label:'用户访谈',
                    value:1
                },{
                    label:'学习成长',
                    value:2
                }],
                quesList1:[]

            }
        },
        computed:{

        },
        components:{
            draggable
        },
        //挂载时候执行
        mounted() {
            this.formInline.classId = this.sectionClassId
            this.getCooperativeList()
//            this.getCooperativeAllUserList()
            if(this.formInline.classId==8){
                this.selectMonth(new Date())
            }else{
                this.selectWeek(new Date())
            }


        },
        methods: {
            //定义查询方法
            getCooperativeList() {
                this.formInline.classId = this.sectionClassId
                this.$store.dispatch('initCooperativeList',this.formInline).then(res=>{
                    this.dataList = res.list
                    this.recordsTotal = res.total
                })
            },
            getCooperativeQues(obj) {
                this.getCooperativeAllUserList();
                this.drawerShow = true;
                this.voitIs = obj.isVoit;
                this.leaderIs = obj.isLeader==2?1:obj.isLeader;
                this.periodId = obj.periodId;
                this.paperId = obj.id;
                this.userId = obj.userId;
                this.editIs = obj.isEdit;
                this.reportStatus= obj.reportStatus;
                this.isNice = obj.isNice;
                this.isLeaderEdit = obj.isLeaderEdit;
                this.isDissentEdit = obj.isDissentEdit;
                this.reportFinish = obj.status;//0未填写 1已填写
                this.title=obj.questionClassName+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                console.log(this.quesList1)
                this.$store.dispatch('initCooperativeQues',{classId:this.formInline.classId,paperId:obj.id}).then(res=>{
                    this.quesList = res
                    let arr = []
                    this.quesList.map(item=>{
                        this.quesList1.map(item2=>{
                            if(item.questionId == item2.questionId){
                                item.answer = item2.answer
                                item.subPaperAnswerEditVos = item2.subPaperAnswerEditVos
                                item.relationEntityList = item2.relationEntityList
                                item.relationEntityListTwo = item2.relationEntityListTwo
                            }

                        })
                        if(item.questionType==3){
                            arr = JSON.parse(item.answer||'[]')
                        }
                        if(item.questionType==9){
                            item.answer = JSON.parse(item.answer.toString())
                        }
                        if(item.questionType==10){
                            item.subPaperAnswerEditVos.map(item1=>{
                                if(item1.questionType==9){
                                    item1.answer = JSON.parse(item1.answer.toString())
                                }
                            })

                        }
                    })
                    this.fileObjList = arr.map(item=>{
                        return {name:item.name,url:item.url}
                    })
                })
            },
            getCooperativeAllUserList() {
                this.$store.dispatch('initCooperativeAllUserList',{type:0,classId:''}).then(res=>{
                    this.userAllList = res
                    this.selectUserList1 = res
                    this.selectUserList = res
                })
            },
            cooperativeLike(id,pId) {
                this.$store.dispatch('cooperativeLikeOrCancle',{periodId:pId,paperId:id,commit:this.likeCommitContent,voteType:this.dialogType}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    this.showDialog=false
                    this.dialogType=1
                    this.drawerShow=false
                    this.likeCommitContent = ''
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeList()
            },
            handleClose(done) {
                this.quesList=[]
                this.voitIs = 0;
                this.editIs = 0;
                this.periodId = '';
                this.paperId = '';
                this.userId = '';
                this.fileObjList = [];
                this.leaderIs = 0;
                this.reportStatus= 0;
                this.isNice = 0;
                this.reportFinish = 0;
                this.getCooperativeList()
                done();
            },
            formSubmit(obj){
                let _this = this;
                let subData = []
                let temRelation = [];
                if(obj){
                    if(obj.questionType==5){
                        temRelation = obj.relationEntityList.filter(item=>{
                            return (item.relationUserId!=null&&item.relationUserId!='')&&(item.content!=null&&item.content!='')
                        })
                    }
                    if(obj.questionType==6||(obj.questionType==13&&this.leaderIs==1)){
                        temRelation = obj.relationEntityList.filter(item=>{
                            return item.content!=null&&item.content!=''
                        })
                    }
                    if(obj.questionType==13&&this.leaderIs==0||obj.questionType==15){
                        temRelation = obj.relationEntityList
                    }
                    if(obj.questionType==10){
                        temRelation = obj.subPaperAnswerEditVos
                    }
                    obj.answer = obj.questionType==3?JSON.stringify(_this.fileObjList):(obj.questionType==5||obj.questionType==6||obj.questionType==10||obj.questionType==13||obj.questionType==15?temRelation:(obj.answer||''))
                    subData = [obj]
                }else{
                    subData = this.quesList.map(item=>{
                        if(item.questionType==5){
                            temRelation = item.relationEntityList.filter(item1=>{
                                return (item1.relationUserId!=null&&item1.relationUserId!='')&&(item1.content!=null&&item1.content!='')
                            })
                        }
                        if(item.questionType==6||(item.questionType==13&&this.leaderIs==1)){
                            temRelation = item.relationEntityList.filter(item1=>{
                                return item1.content!=null&&item1.content!=''
                            })
                        }
                        if(item.questionType==13&&this.leaderIs==0||item.questionType==15){
                            temRelation = item.relationEntityList
                        }
                        if(item.questionType==10){
                            temRelation = item.subPaperAnswerEditVos
                        }
                        let newItem = {
                            paperId:item.paperId||'',
                            questionId:item.questionId||'',
                            answer:item.questionType==3?JSON.stringify(_this.fileObjList):(item.questionType==5||item.questionType==6||item.questionType==10||item.questionType==13||item.questionType==15?temRelation:(item.answer||''))
                        }
                        return newItem
                    })
                }

                console.log(subData)
                this.$store.dispatch('submitCooperativeQues',{answerEntityList:JSON.stringify(subData)}).then(res=>{
                    if(!obj){
                        this.drawerShow = false;
                        this.getCooperativeList();
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success'
                        });
                    }

                })
            },
            handleFileChange(file,fileList){
                console.log(file)
                this.fileObjList = this.fileObjList.concat(file.value)
            },
            handleFileView(file){
                window.open(file.url)
            },
            handleFileRemove(file,fileList){
                this.fileObjList = fileList
            },
            querySearchFun(queryString) {
                var restaurants = this.userAllList;
                return queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            },
            querySearch(queryString) {
                this.selectUserList =this.querySearchFun(queryString);
            },
            querySearch1(queryString) {
                this.selectUserList1 = this.querySearchFun(queryString);
            },
            selectFocus(index){
                this.currentSelectIndex = index
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.USER_NAME.indexOf(queryString) >-1);
                }
            },
            addQues(item){
                let _this = this
                item.relationEntityList.push({
                    answerId: null,
                    content: null,
                    createTime: null,
                    id: null,
                    relationUserId: null,
                    relationUserName: null,
                    isLeader:_this.leaderIs
                })
            },
            minuQues(item,rel,index){
                item.relationEntityList.splice(index,1);
                this.formSubmit(item)
            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            selectWeek(val){
                this.$store.dispatch('cooperativeWeekInfo',{date:val}).then(res=>{
                    this.formInline.year = res.headYear
                    this.formInline.period = res.headPeriod

                })
            },
            selectMonth(val){
                this.formInline.year = val.getFullYear()
                this.formInline.period = val.getMonth()+1
            },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            },
            submitLeaderComment(id,pId){
                this.$store.dispatch('saveModityPaperStatusInfo',{id:id,reportStatus:this.reportStatus?1:0,isNice:this.isNice?1:0}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    this.showDialogLeader=false
                    this.reportStatus=0
                    this.isNice=0
                })
            },
            submitWeekCheck(item){
                this.$store.dispatch('savemodityWeekAfterWeek',{id:item.id,isFinishEmploye:item.isFinishEmploye,isFinishLeader:item.isFinishLeader}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                })
            },
            changeListSort(item){
                console.log(item.moved)
                let element = item.moved.element;
                this.$store.dispatch('modifyPaperAnswerRelationSortInfo',{answerRelationId:element.id,questionId:element.questionId,sort:item.moved.newIndex+1,classId:this.formInline.classId,paperId:this.paperId,userId:this.userId}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: 'success',
                        type: 'success'
                    });
                })
            },
            downloadExcel(){
                let url = `${downloadExcelCooperative}?classId=${this.formInline.classId}&year=${this.formInline.year}&period=${this.formInline.period}&pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            selectWeek1(val){
                this.$store.dispatch('cooperativeWeekInfo',{date:val}).then(res=>{
                    this.$store.dispatch('initCooperativeList',{
                        currentPage: 1,
                        pageSize: 50,
                        classId:this.sectionClassId,
                        year:res.headYear,
                        period:res.headPeriod,
                        userId:'',
                        pageRouterUrl:'userinterview'
                    }).then(res=>{
                        this.dataList1 = res.list
                    })

                })
            },
            getCooperativeQues1(id){
                this.$store.dispatch('initCooperativeQues',{classId:this.formInline.classId,paperId:id}).then(res=>{
                    this.$notify({
                        title: '获取数据成功',
                        message: res,
                        type: 'success'
                    });
                    this.quesList1 = res
                })
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }

    .el-textarea__inner{
        min-height: 40px !important;
    }
    .cooperate-form {
        .el-input-number{
            width: 220px !important;
        }
        .el-select{
            width: 100%;
        }
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        td,th{
            padding: 12px 0;
            border:1px solid #EBEEF5;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/views/cooperative/setGrowthInterview.vue